module.exports = __webpack_public_path__ + "static_pc/img/strabanner.8b974ebb.png";